import { calculateBMI } from './components/Helpers/Conversion';
// account should be the only one using this
// all items will be cleared when account/session expires
function setSessionStorageItemWithExpiration(key, value, timeoutInMinutes) {
  const now = new Date();

  const expireTime = new Date(now.getTime() + timeoutInMinutes * 60000);

  const storeItem = {
    value: value,
    expiration: expireTime,
  };

  try {
    sessionStorage.setItem(key, JSON.stringify(storeItem));
  } catch (e) {
    if (e.code === 22) {
      console.log('Session storage full.');
    }
  }
}

function setSessionStorageItem(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    if (e.code === 22) {
      console.log('Session storage full.');
    }
  }
}

function setQuotesToCompare(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}

function getQuotesToCompare(key) {
  const item = sessionStorage.getItem(key);
  if (!item) {
    window.location = '/Products/ABLTC/Quote';
  } else return JSON.parse(item);
}

function getSessionStorageItem(key) {
  const item = sessionStorage.getItem(key);

  if (!item) {
    return null;
  }

  const itemJson = JSON.parse(item);

  if (itemJson.expiration) {
    const currentTime = new Date();
    const expireTime = new Date(itemJson.expiration);

    if (currentTime > expireTime) {
      try {
        fetch('SSO/LogOut');
      } catch (ex) {
        window.location = '/';
        return null;
      }

      if (shouldRedirect()) {
        sessionStorage.clear();

        // redirect to home screen after expiration
        window.location = '/';
      }
      
      return null;

    } else {
      // if expiring item, extend timeline
      setSessionStorageItemWithExpiration(key, itemJson.value, 60);
    }
  }

  return itemJson.value || itemJson;
}

function shouldRedirect() {
  let currentURL = window.location.href.split('/');
  const pagesToPreventRedirectOnExpire = ['status', 'landing', 'retrieveprogress'];

  // remove any query strings
  currentURL = currentURL.map((url) => url.split('?')[0]);

  if (currentURL.some((urlSegment) => pagesToPreventRedirectOnExpire.includes(urlSegment.toLowerCase()))) {
    return false;
  }

  return true;
}

// define the standard basic info data
var basicInfo = {
  firstName: null,
  lastName: null,
  phone: null,
  gender: null,
  birthdate: null,
  tobacco: null,
  state: null,
  height: null,
  weight: null,
  email: null,
  usResident: null,
  replacePolicy: null,
  preQuoteHealthClass: null,
  preQuoteAbbreviatedQualified: null,
  bmi: null,
  coverageLength: null,
  faceAmount: null,
  healthClass: null,
  income: null,
};

// Grab Basic Info from localstorage, if not there return a new one
function getBasicInfo() {
  var basicInfoFromStorage = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_BASIC_INFO_KEY)) || basicInfo;

  if (!basicInfoFromStorage.birthdate && getSessionStorageItem(SESSION_STORAGE_CLIENTINFO_KEY)) {
    var clientInfo = getSessionStorageItem(SESSION_STORAGE_CLIENTINFO_KEY);
    basicInfoFromStorage.phone = clientInfo.phone;
    basicInfoFromStorage.gender = clientInfo.gender;
    basicInfoFromStorage.birthdate = clientInfo.dateOfBirth;
    basicInfoFromStorage.tobacco = String(clientInfo.tobacco);
    basicInfoFromStorage.state = clientInfo.state;
    basicInfoFromStorage.height = clientInfo.heightString;
    basicInfoFromStorage.weight = clientInfo.weightString;
    basicInfoFromStorage.email = clientInfo.email;
    basicInfoFromStorage.usResident = clientInfo.usResident;
    basicInfoFromStorage.replacePolicy = clientInfo.replacePolicy;
    basicInfoFromStorage.bmi = calculateBMI(clientInfo.totalInches, clientInfo.weight) || undefined;
    basicInfoFromStorage.coverageLength = clientInfo.termLength;
    basicInfoFromStorage.faceAmount = clientInfo.faceAmount;
    basicInfoFromStorage.healthClass = clientInfo.healthClass;
    basicInfoFromStorage.firstName = clientInfo.firstName;
    basicInfoFromStorage.lastName = clientInfo.lastName;
    basicInfoFromStorage.income = clientInfo.income;
    basicInfoFromStorage.termLength = clientInfo.termLength;
  }

  return basicInfoFromStorage;
}

// Save Basic Info to local storage
function setBasicInfo(basicInfo) {
  sessionStorage.setItem(SESSION_STORAGE_BASIC_INFO_KEY, JSON.stringify(basicInfo));
}

export { setSessionStorageItemWithExpiration, setQuotesToCompare, setSessionStorageItem, getQuotesToCompare, getSessionStorageItem, getBasicInfo, setBasicInfo };

// keys
export const SESSION_STORAGE_COMPARE_QUOTES_KEY = 'COMPARE_QUOTE_OBJECT';
export const SESSION_STORAGE_ACCOUNT_CARRIERS_KEY = 'ACCOUNT_CARRIERS_OBJECT';
export const SESSION_STORAGE_ACCOUNT_KEY = 'ACCOUNT_OBJECT';
export const SESSION_STORAGE_ACCOUNT_PRODUCT_SETTINGS_KEY = 'ACCOUNT_PRODUCT_SETTINGS_OBJECT';
export const SESSION_STORAGE_COVERAGE_AMOUNT_KEY = 'COVERAGE_AMOUNT';
export const SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY = 'TERM_COVERAGE_AMOUNT';
export const ADVISOR_CASES_STATUS_HIGH_LEVEL_KEY = 'ADVISOR_CASES_STATUS_HIGH_LEVEL_KEY';
export const ADVISOR_ACTIVITY_CENTER_KEY = 'ADVISOR_ACTIVITY_CENTER_KEY';
export const ADVISOR_ACTIVITY_CENTER_SUMMARY_DETAILS_KEY = 'ADVISOR_ACTIVITY_CENTER_SUMMARY_DETAILS_KEY';
export const SESSION_STORAGE_TERM_LENGTH_KEY = 'TERM_LENGTH';
export const SESSION_STORAGE_COVR_FULLUW_KEY = 'COVR_FULLUW';
export const SESSION_STORAGE_DISABILITY_KEY = 'DISABILITY_QUOTE';
export const SESSION_STORAGE_ESIGN_AUTH_KEY = 'ESIGN_AUTH';
export const SESSION_STORAGE_HEALTH_CLASS_KEY = 'HEALTH_CLASS';
export const SESSION_STORAGE_NEEDS_ANALYSIS_KEY = 'INSURANCE_NEEDS_ANALYSIS';
export const SESSION_STORAGE_TERM_ALTERNATIVES_KEY = 'TERM_ALTERNATIVES';
export const SESSION_STORAGE_TERM_PRE_RUN_QUOTE_KEY = 'TERM_PRE_RUN_QUOTE';
export const SESSION_STORAGE_AMERICO_DECLINED_REASONS_KEY = 'AMERICO_DECLINED_REASONS';
export const SESSION_STORAGE_BASIC_INFO_KEY = 'BASIC_INFO';
export const SESSION_STORAGE_TERM_PREDICTIVE_QUOTE_KEY = 'TERM_PREDICTIVE_QUOTE';
export const SESSION_STORAGE_CLIENTINFO_KEY = 'CLIENTINFO_OBJECT';
export const SESSION_STORAGE_AGENT_CLIENTS = 'AGENT_CLIENTS';
export const ADVISOR_OBJECT_KEY = 'ADVISOR_OBJECT';
export const SESSION_STORAGE_TERM_LIFE_INSURANCE_OBJECT_KEY = 'TERM_LIFE_INSURANCE';
export const SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY= 'PERM_LIFE_INSURANCE';
export const ADVISOR_BASIC_INFO_KEY = 'ADVISOR_BASIC_INFO_KEY';
export const SESSION_STORAGE_CLIENT_TABLE_KEY = 'CLIENT_TABLE_KEY';
export const ACTIVITY_OBJECT_KEY = 'ACTIVITY_OBJECT_KEY';
export const SESSION_STORAGE_SCHEDULE_APPOINTMENT_KEY = 'SCHEDULE_APPOINTMENT_KEY';
export const SESSION_STORAGE_REQUEST_ILLUSTRATIONS_OBJECT_KEY = 'REQUEST_ILLUSTRATIONS';
export const SESSION_STORAGE_EXISTINGINSURANCE_MESSAGE_KEY = 'EXISTINGINSURANCE_MESSAGE';
export const SESSION_STORAGE_SPWL_KEY = 'SESSION_STORAGE_SPWL_KEY';
export const SPWL_SCHEDULE_APPOINTMENT_KEY = 'SPWL_SCHEDULE_APPOINTMENT_KEY';
export const SESSION_SAVE_QUOTE_KEY = 'SAVE_QUOTE_KEY';
export const ILLUSTRATION_PREFILL_DATA = 'ILLUSTRATION_DATA';
export const SERVICES_BASE_URL_KEY = 'SERVICES_BASE_URL_KEY';
export const SELECTED_PRODUCT_FOR_ILLUSTRATION = 'SELECTED_PRODUCT_FOR_ILLUSTRATION';
export const SELECTED_PRODUCT_FOR_SUBMIT_A_CASE = 'SELECTED_PRODUCT_FOR_SUBMIT_A_CASE';
export const SELECTED_SUPERVISORY_TICKET_ID = 'SELECTED_SUPERVISORY_TICKET_ID';
export const TRANSACTIONTYPES_KEY = "TRANSACTIONTYPES_KEY";
export const ACTIVITY_CENTER_FILTER_KEY = "ACTIVITY_CENTER_FILTER_KEY";
export const SESSION_STORAGE_TERM_REVIEW_OBJECT_KEY = "TERM_REVIEW";
export const SESSION_STORAGE_CREATE_CASE = "SESSION_STORAGE_CREATE_CASE";
export const SESSION_STORAGE_CASE_RETURN_PATH = "CASE_RETURN_PATH";
export const SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY = "PERM_REVIEW";
export const SESSION_STORAGE_ABLTC_OBJECT_KEY = "ASSET_BASED_LTC";
export const SESSION_STORAGE_NOTIFICATION = "NOTIFICATION_KEY";
export const SESSION_STORAGE_ATTESTATION = "ATTESTATION_KEY";
export const SESSION_STORAGE_CLIENT_ACCOUNT_INFO = "CLIENT_ACCOUNT_INFO";
export const SESSION_STORAGE_IS_SYSTEM_OUTAGE_ALERT = "IS_SYSTEM_OUTAGE_ALERT";




// WEBPACK FOOTER //
// ./src/sessionStorage.js